import React from "react";
import styled from "styled-components";
import { FaPencilAlt } from "react-icons/fa";

import { apiBaseUrl } from "apis/apiHelpers.js";
import { PRODUCT_RELEASE_EDIT_LABEL } from "constants.js";

const EditProduct = ({ className, productReleaseId, productId }) => {
  const linkTo = `${apiBaseUrl}/${productReleaseId}/for/${productId}/product_details?label=${PRODUCT_RELEASE_EDIT_LABEL}`;

  return (
    <div className={className}>
      <div className="item-edit">
        <span>
          <a
            href={linkTo}
            target="_blank"
            rel="noopener noreferrer"
            title="Edit product release details"
          >
            <FaPencilAlt className="edit-icon" fill="#bdbdbd" size={16} />
          </a>
        </span>
      </div>
    </div>
  );
};

const StyledEditProduct = styled(EditProduct)`
  cursor: pointer;
  margin: 0 auto;

  .item-edit {
    background-color: #ffffff;
    position: static;
    border: solid 1.5px #e5e5e5;
    border-radius: 3px;
    color: #c1c1c1;
    font-family: "Roboto";
    font-size: 10px;
    font-weight: 600;
    text-align: center;
    width: 28px;
    height: 28px;
    margin-top: 1ex;
  }

  .edit-icon {
    margin-top: 5px;
  }
`;

export default React.memo(StyledEditProduct);
